import { render, staticRenderFns } from "./NewsEntry.vue?vue&type=template&id=3ddc9947&scoped=true"
import script from "./NewsEntry.vue?vue&type=script&lang=js"
export * from "./NewsEntry.vue?vue&type=script&lang=js"
import style0 from "./NewsEntry.vue?vue&type=style&index=0&id=3ddc9947&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddc9947",
  null
  
)

export default component.exports